import $ from 'jquery';
import MessageHandler from './jwplayer-message-handler';
import adTagBuilder from './jwplayer-ads';

class JWPlayerInit {
    constructor() {
        this.adTag = adTagBuilder.adUrl;
        this.$vid = $('#video');
        this.ext = document.createElement('video').canPlayType('video/webm') ? 'webm' : 'mp4';
        this.size = window.innerWidth < 481 ? '480' : '720';
        this.player = {};
        this.playlistCalled = false;
        this.autoplay = (window.location.search.search(/autoplay\=1/) !== -1) ? true : false;
        this.options = {
            file: this.$vid.data(this.ext + this.size),
            image: this.$vid.data('poster'),
            title: this.$vid.data('title'),
            description: this.$vid.data('desc'),
            mediaid: this.$vid.data('id'),
            autostart: this.autoplay,
            advertising: {
                client: 'googima',
                tag: this.adTag
            },
            ga: {}, // for prod
            skin: {
                name: 'fc-custom'
            } //,
            // sharing: {
            //     code: encodeURI('<iframe width="720" height="415" src="//www.fastcompany.com/embed/MEDIAID?rel=1&src=embed&veggiemode=1" frameborder="0" scrolling="no" allowfullscreen></iframe>')
            //     //link: parent ? parent.document.URL : 'http://www.fastcompany.com/embed/MEDIAID'
            // }
        };

        // Keep mute options outside the object so they don't reset themselves when player reloads
        this.options.mute = true;
        if (this.autoplay) {
            this.options.mute = false;
        }

        this.playlistOptions = Object.assign({}, this.options);
        this.playlistOptions.playlist = '//content.jwplatform.com/feeds/gE5uQSi7.rss';
        this.playlistOptions.autostart = true;
    }

    initPlayer() {
        this.player.setup(this.options);

        this.player.on('ready', function () {
            var messageHandler = new MessageHandler(this);
            messageHandler.on();
        });

        this.player.on('complete', function () {
            this.loadPlaylist();
        }.bind(this));
    }

    loadPlaylist() {
        if (!this.playlistCalled) {
            this.player.setup(this.playlistOptions);
            this.playlistCalled = true;
        }
    }

    on() {
        $.getScript('//content.jwplatform.com/libraries/G2hQKLvX.js', function () {
            this.player = jwplayer('video');
            this.initPlayer();
        }.bind(this));
    }

    off() {
        this.player = {};
    }
}

export default new JWPlayerInit();
